import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tousu",
  "use": "icon-tousu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tousu\"><defs><style type=\"text/css\"></style></defs><path d=\"M934.4 505.6c25.6-25.6 25.6-70.4 0-96L633.6 102.4c-25.6-25.6-70.4-25.6-96 0l-448 441.6c-25.6 25.6-25.6 70.4 0 102.4L320 870.4H70.4v70.4h876.8v-70.4h-384l371.2-364.8zM256 640l-6.4-64 288-19.2 19.2-288 64 6.4-19.2 339.2L256 640z\" p-id=\"3824\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol